import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ConcurrencyControlTechniques = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Concurrency Control Techniques"
    videos={[
      "https://www.youtube.com/embed/27NtGV1vNoY?si=MiODI3KxvWjBikQM",
      "https://www.youtube.com/embed/MKIoDIuVsr4?si=POl3OkbGGVZt2OeF",
      "https://www.youtube.com/embed/u3-Pir22Om8?si=8zDakklSVyFI98IL",
      "https://www.youtube.com/embed/MX_Gtn4l9ys?si=GpzNOB3VN109GBzD",
      "https://www.youtube.com/embed/XFl2y2RbplI?si=T65yFxiC11-ydoRW",
      "https://www.youtube.com/embed/VDm7bA_odiY?si=LC-j0x7LFDLsON0h"
    ]}
    takeaways={[]}
    questions={[
      "1) Discuss the timestamp ordering protocol for concurrency control. How does strict timestamp ordering differ from basic timestamp ordering?",
      "2) Compare binary locks to exclusive/share locks. Why is the latter type of locks preferable?",
      "3) Consider the following transactions with their respective timestamps: T1: Timestamp = 150 T2: Timestamp = 250 T3: Timestamp = 350 Given the schedule of operations: S: R1(X); R2(Y); W1(Z); R3(Y); W2(X); R1(Y); W3(Z)",
      "  i) Apply the Timestamp Ordering Protocol to determine the order of transaction execution.",
      "  ii) Identify which operations are allowed and which are aborted based on the protocol rules.",
      "  iii) Explain the reasons for any transaction aborts in the schedule and discuss how this affects the overall consistency of the transactions."
    ]}
    exampleVideos={[]}
  />
);
}

export default ConcurrencyControlTechniques;
